import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { User } from "../models/user";
import { environment } from "src/environments/environment";
import { GlobalService } from "src/services/global.service";
import { AuthApiService } from "src/app/authentication/shared/auth-api.service";
import Swal from "sweetalert2";
import { TranslateService } from "@ngx-translate/core";
import { SocialAuthService } from "angularx-social-login";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  public currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  is_sideMenuHeader = true
  constructor(
    private http: HttpClient,
    private global: GlobalService,
    private authAPI: AuthApiService,
    private translate: TranslateService,
    private socialAuthService: SocialAuthService,
    private router: Router
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem("currentUser"))
    );
    this.currentUser = this.currentUserSubject.asObservable();
    if (this.currentUser) {
      this.global.currentUser = JSON.parse(localStorage.getItem("currentUser"))
    }
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  patientLogin(formData) {
    return this.authAPI.patientLogin(formData)

    // return this.http
    //   .post<any>(`${environment.apiUrl}/patient/login`, formData)
    //   .pipe(
    //     map((user) => {
    //       // store user details and jwt token in local storage to keep user logged in between page refreshes
    //       console.log(user)
    //       localStorage.setItem("currentUser", JSON.stringify(user));
    //       this.currentUserSubject.next(user);
    //       return user;
    //     })
    //   );
  }
  hospitalLogin(formData) {
    return this.authAPI.hospitalLogin(formData)
  }
  doctorLogin(formData) {
    return this.authAPI.doctorLogin(formData)
  }
  socialPatientLogin(formData) {
    return this.authAPI.socialPatientLogin(formData)
  }
  socialDoctorLogin(formData) {
    return this.authAPI.socialDoctorLogin(formData)
  }
  socialHospitalLogin(formData) {
    return this.authAPI.socialHospitalLogin(formData)
  }
  patientRegister(formData) {
    return this.authAPI.patientRegistration(formData)
  }
  doctorRegister(formData) {
    return this.authAPI.doctorRegistration(formData)
  }
  hospitalRegister(formData) {
    return this.authAPI.hospitalRegistration(formData)
  }
  doctor_registration_number(formData) {
    return this.authAPI.doctor_registration_number(formData)
  }
  otp_send(formData) {
    return this.authAPI.otp_send(formData)
  }
  otp_resend(formData) {
    return this.authAPI.otp_resend(formData)
  }



  admin_login(formData) {
    this.authAPI.adminLogin(formData)
      .then((res: any) => {
        localStorage.setItem("currentUser", JSON.stringify(res['admin']));
        this.currentUserSubject.next(res['admin']);
        this.router.navigate(['/admin/dashboard'])
      }).catch(err => {
        // console.log(err)
        Swal.fire({
          title: this.translate.instant('Error!'),
          text: err.message,
        });
      });
  }
  //---------------Pharmacy Login----------------
  pharmacy_login(formData) {
    this.authAPI.pharmacyLogin(formData)
      .then((res: any) => {
        // console.log(res)
        localStorage.setItem("currentUser", JSON.stringify(res.store));
        localStorage.setItem('authentication_token', res.access_token);
        this.currentUserSubject.next(res.store);
        this.router.navigate(['/pharmacy/my-orders'])
      }).catch(err => {
        // console.log(err)
        Swal.fire({
          title: this.translate.instant('Error!'),
          text: err.message,
          // text: err.data.password
        });
      });
  }
  //   pharmacy_login(username: string, password: string) {
  //     if (username == "pharmacy@pharmacy.com" && password == "pharmacy@123" ) {
  //     let user = {
  //       address: "",
  //       created_at: "2021-08-10",
  //       current_balance: "0",
  //       dob: "",
  //       email: "pharmacy@pharmacy.com",
  //       experience: "",
  //       fees: "",
  //       gender: "male",
  //       id: "DR00000003",
  //       latitude: "",
  //       longitude: "",
  //       mobile: "9975737199",
  //       name: "Steven Smith",
  //       password: "pharmacy@123",
  //       phone_code: "+91",
  //       picture: "",
  //       rating: "0",
  //       role: "pharmacy",
  //       services: "",
  //       services_at: "",
  //       status: "Active"
  //     }
  //     localStorage.setItem("currentUser", JSON.stringify(user));
  //     this.currentUserSubject.next(user);
  //     this.router.navigate(["/pharmacy/dashboard"]);
  //   }
  //  else if ( username ==  "drugstore@pharmacy.com" && password ==  "drungstore@123" ) {
  //     let user = {
  //       address: "",
  //       created_at: "2021-08-10",
  //       current_balance: "0",
  //       dob: "",
  //       email: "drugstore@pharmacy.com",
  //       experience: "",
  //       fees: "",
  //       gender: "male",
  //       id: "DR00000003",
  //       latitude: "",
  //       longitude: "",
  //       mobile: "9975737199",
  //       name: "Stephen",
  //       password: "drungstore@123",
  //       phone_code: "+91",
  //       picture: "",
  //       rating: "0",
  //       role: "Drugstore",
  //       services: "",
  //       services_at: "",
  //       status: "Active"
  //     }
  //     localStorage.setItem("currentUser", JSON.stringify(user));
  //     this.currentUserSubject.next(user);
  //     this.router.navigate(["/drugstore/dashboard"]);
  //   }
  // }



  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem("currentUser");
    this.currentUserSubject.next(null);
    this.socialAuthService.authState.subscribe((user) => {
      // console.log(user)
      if (user) {
        this.socialAuthService.signOut();
      }
    });
    return of({ success: false });
  }

}
